function validateEmail(email) {
  var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

// validate footer
function validate() {
var $result = $("#Email");
var email = $("#Email").val();
var form = $(".footer__bottom-form");
$result.text("");

if (validateEmail(email)) {
//submit
$("#contact_form").submit();
} else {
  if ($result.val()) {
    $result.val("");
    $result.attr("placeholder", "Please enter a valid Email");
  }
}
return false;
}

$("#contact_form").on("click", validate);
